import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead'
import { NaturezaVendaFilterModule } from '../filter';
import { NaturezaVendaSituacaoModule } from '../situacao';

import { NaturezaVendaTypeaheadComponent } from './natureza-venda-typeahead.component';

@NgModule({
    imports: [
        SharedModule,
        TypeaheadModule,
        NaturezaVendaFilterModule,
        NaturezaVendaSituacaoModule
    ],
    declarations: [
        NaturezaVendaTypeaheadComponent
    ],
    exports: [
        NaturezaVendaTypeaheadComponent
    ]
})
export class NaturezaVendaTypeaheadModule { }
